import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d98aa11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-center justify-space-between cursor-pointer item-drag" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "font-500 text-sm" }

import { computed } from 'vue';
import Draggable from 'vuedraggable';
import * as comps from '@/components/atoms';
import { AtomCheckBox } from '@/components/atoms';
import { IHeadersTable } from '@/types'

interface IProps {
  modelValue: IHeadersTable[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeReorderItems',
  props: {
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: IHeadersTable[];
};





const value = computed({
  get(): IHeadersTable[] {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  }
})

function handleChange(item) {
  if (item.moved) {
    let newIndex = item.moved.newIndex + 1
    let oldIndex = item.moved.oldIndex + 1
    newIndex = newIndex + (newIndex > oldIndex ? .1 : -.1)
    value.value[oldIndex - 1].orderItem = newIndex
    value.value.sort((a: any, b: any) => (a.orderItem > b.orderItem) ? 1 : -1)
    value.value.map((option: any, index: number) => option.orderItem = index + 1)
  }
  console.log(item)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Draggable), {
    "model-value": _unref(value),
    "item-key": "field",
    onChange: handleChange
  }, {
    item: _withCtx(({ element }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(AtomCheckBox), {
            "no-margin": "",
            modelValue: element.checked,
            "onUpdate:modelValue": ($event: any) => ((element.checked) = $event),
            checked: element.checked
          }, null, 8, ["modelValue", "onUpdate:modelValue", "checked"]),
          _createElementVNode("p", _hoisted_3, _toDisplayString(element.label), 1)
        ]),
        (_openBlock(), _createBlock(_resolveDynamicComponent(comps['ReorderIcon'])))
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})